import React, { Component } from 'react';
import { getMobileOperatingSystem } from '@flow/utils/deviceDetection';
import { AddToMyFlow, HashMapItem, RemoveFromMyFlow } from 'types/MyFlow';
import { MyFlowState } from '@flow/store/myflow/reducer';
import { connect } from 'react-redux';
import * as myFlowActions from '@flow/store/myflow/actions';
import {
  MyFlowContent,
  MyFlowContentHeader,
  MyFlowMenuArrow,
  MyFlowScheduleActionBar,
  MyFlowScheduleDayList,
  MyFlowScheduleListsWrapper,
  MyFlowTitle,
  MyFlowWrapper,
  PrintButton,
} from '@flow/scenes/schedule/ui';
import ReactToPrint from 'react-to-print';
import { Day, filterSelectedEvents, sortEventItemsByDay, sortEventsByTimeDESC } from '@flow/utils/helperUtils';
import { renderDayTitle } from '@flow/scenes/schedule/ui/Schedule';
import { ListActionItem } from '@flow/scenes/schedule/ui/ListActionItem';
import { FormattedMessage } from 'react-intl';

interface Props {
  appLanguage: IAppLanguage;
  user: User;
  myFlow: MyFlowState;
  addToMyFlow: (params: AddToMyFlow) => any;
  removeFromMyFlow: (params: RemoveFromMyFlow) => any;
}

interface State {
  isExpanded: boolean;
}

class MyScheduleConnected extends Component<Props, State> {
  noScroll: any;
  printAreaRef: any;
  document: HTMLDocument;

  constructor(props: Props) {
    super(props);

    this.noScroll = require('no-scroll');

    this.state = {
      isExpanded: false,
    };
  }

  componentDidMount() {
    this.document = document;
  }

  render() {
    const {
      user,
      myFlow,
      appLanguage,
    } = this.props;

    if(!user) {
      return null;
    }

    const { isExpanded } = this.state;

    if (isExpanded) {
      if (this.document)  {
        this.document.body.classList.add('no-scroll');
        if (getMobileOperatingSystem() === 'iOS') this.noScroll.on();
      }
    } else {
      if (this.document) {
        this.document.body.classList.remove('no-scroll');
        if (getMobileOperatingSystem() === 'iOS') this.noScroll.off();
      }
    }

    const selectedEventsHashMap = filterSelectedEvents(myFlow.eventIdHashMap, myFlow.scheduleIdList);
    const eventsByDay = sortEventItemsByDay(selectedEventsHashMap, sortEventsByTimeDESC);

    return (
      <MyFlowWrapper className={isExpanded ? 'is-open' : ''}>
        <MyFlowContentHeader onClick={() => {this.setState({isExpanded: !isExpanded})}}>
          <MyFlowTitle>
            <FormattedMessage id={'myFlow.title'} />
          </MyFlowTitle>
          <MyFlowMenuArrow>→</MyFlowMenuArrow>
        </MyFlowContentHeader>
        <MyFlowContent>
          <MyFlowScheduleActionBar style={{ visibility: (eventsByDay && eventsByDay.length) ? 'visible' : 'hidden' }}>
            <ReactToPrint
              trigger={() => <PrintButton><FormattedMessage id={'myFlow.print'} /></PrintButton>}
              content={() => this.printAreaRef}
              copyStyles={false}
              pageStyle={`
                .my-flow-schedule-wrap {
                  padding: 28px;
                  font-family: 'Flow-Text';
                  box-sizing: border-box;
                }

                .my-flow-schedule-day-list {
                  font-family: sans-serif;
                  display: block;
                }

                .my-flow-schedule-day-list .day-title {
                  font-size: 20px;
                  margin-bottom: 10px;
                }

                .my-flow-schedule-day-list__items {
                  padding-left: 0;
                }

                .my-flow-schedule-day-list__items li {
                  display: block;
                  width: 100%;
                  font-size: 16px;
                  line-height: 1.4;
                  list-style: none;
                  margin-bottom: 14px;
                }

                .my-flow-schedule-day-list__items li > span {
                  display: flex;
                }

                .my-flow-schedule-day-list__items li .artist-event-time {
                  font-size: 14px;
                  font-weight: bold;
                  min-width: 68px;
                }

                .my-flow-schedule-day-list__items li .artist-title-and-venue {
                  color: black;
                  text-decoration: none;
                  display: block;
                }

                .my-flow-schedule-day-list__items li .artist-title-and-venue > span {
                  display: block;
                  font-size: 14px;
                  margin-top: 7px;
                  font-weight: bold;
                }
            `}
            />
          </MyFlowScheduleActionBar>

          <MyFlowScheduleListsWrapper ref={(el: any) => (this.printAreaRef = el)} className={'my-flow-schedule-wrap'}>
            {eventsByDay.map((day: Day, idx: number) => (
              <MyFlowScheduleDayList key={idx} className={'my-flow-schedule-day-list'}>
                <h2 className='day-title' style={{ textTransform: 'uppercase' }}>
                  {renderDayTitle(appLanguage.code, day.date, 'ddd DD.M.')}
                </h2>
                <ul className={'my-flow-schedule-day-list__items'}>
                  {day.events && day.events.map((item: HashMapItem, index: number) =>
                    <ListActionItem item={item} key={index} showVenue={true} />
                  )}
                </ul>
              </MyFlowScheduleDayList>
            ))}
          </MyFlowScheduleListsWrapper>
        </MyFlowContent>
      </MyFlowWrapper>
    )
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    addToMyFlow: (params: AddToMyFlow) => dispatch(myFlowActions.addToMyFlow(params)),
    removeFromMyFlow: (params: RemoveFromMyFlow) => dispatch(myFlowActions.removeFromMyFlow(params)),
  };
};

export const MySchedule = connect(
  (state: any) => ({
    user: state.auth.user,
    myFlow: state.myFlowReducer,
  }), mapDispatchToProps
)(MyScheduleConnected);


// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/scenes/schedule/ui/MySchedule.tsx